<!-- Overlay only when non-persistent: persistent sheets (e.g. action bar) must not block the page -->
<div
  class="overlay"
  *ngIf="isVisible && service && !persistent"
  [class.inline]="!fullScreen"
  [@fadeIn]
  (click)="close()"
></div>

<div class="container-sheet" [class.service]="service" [class.inline]="!fullScreen" (click)="!persistent && close()">
  <div
    class="bottom-sheet"
    *ngIf="isVisible"
    [@slideUp]
    (@slideUp.done)="onAnimationDone($event)"
    #bottomSheet
    (click)="$event.stopPropagation()"
  >
    <div *ngIf="title || src || description" class="header">
      <img
        [src]="line"
        alt="resize"
        *ngIf="description && showResizeHandle"
        #resizeHandle
        class="resize-handle"
        (mousedown)="onResizeStart($event)"
        (touchstart)="onResizeStart($event)"
      />
      <div class="text-container">
        <span *ngIf="title" class="title">{{ title }}</span>
        <img *ngIf="src" class="illustration" [src]="src" alt="illustration" />
        <span *ngIf="description" #descriptionElement class="description" [style.--line-clamp]="maxLines">{{
          description
        }}</span>
      </div>
    </div>
    <div
      class="buttons-container"
      [class.buttons-end]="buttonsAlign === 'end'"
      [class.buttons-start]="buttonsAlign === 'start'"
    >
      <ng-container *ngIf="rows?.length; else legacyButtons">
        <div
          class="buttons-row row-ordered"
          [style.--row-priority]="row.priority ?? i"
          [ngClass]="{ single: row.buttons.length === 1 }"
          *ngFor="let row of rows; let i = index"
        >
          <ds-button
            *ngFor="let btn of row.buttons"
            [color]="btn.kind || 'primary'"
            [size]="btn.size || 'md'"
            width="full"
            [icon]="btn.icon"
            [label]="btn.label"
            [dsIcon]="btn.dsIcon"
            [disabled]="btn.disabled"
            [dsTooltip]="btn.tooltip"
            (click)="onClick(btn.action)"
          ></ds-button>
        </div>
      </ng-container>
      <ng-template #legacyButtons>
        <div *ngIf="buttons.length > 0" class="primary-buttons">
          <ds-button
            class="primary-button"
            color="primary"
            size="md"
            width="fixed"
            fixedWidth="100%"
            [icon]="buttons[0].icon"
            (click)="onClick(buttons[0].action)"
            [label]="buttons[0].label"
            [dsIcon]="buttons[0].dsIcon"
            [disabled]="buttons[0].disabled"
            [dsTooltip]="buttons[0].tooltip"
          >
          </ds-button>

          <ds-button
            *ngIf="buttons.length > 1"
            class="secondary-button"
            color="secondary"
            size="md"
            width="fixed"
            fixedWidth="100%"
            [icon]="buttons[1].icon"
            (click)="onClick(buttons[1].action)"
            [label]="buttons[1].label"
            [dsIcon]="buttons[1].dsIcon"
            [disabled]="buttons[1].disabled"
            [dsTooltip]="buttons[1].tooltip"
          >
          </ds-button>
        </div>

        <div *ngIf="buttons.length > 2" class="tertiary-buttons">
          <ds-button
            class="d-flex justify-content-center"
            *ngFor="let btn of buttons.slice(2); let i = index"
            color="tertiary"
            size="md"
            [icon]="btn.icon"
            (click)="onClick(btn.action)"
            [label]="btn.label"
            [dsIcon]="btn.dsIcon"
            [disabled]="btn.disabled"
            [dsTooltip]="btn.tooltip"
          >
          </ds-button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
